let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g59NM")).then(() => parcelRequire('aiZVu'));